import React from 'react';
import { Tooltip } from '@thd-olt-component-react/tooltip';

const RestartText = React.forwardRef(function Content(props, ref) {
  return (
    <p>
      There are a few reasons why you may need to restart your verification: the verification failed, expired, or
      there was an error in your application information. If you encounter any of these cases, you will need to
      restart the verification process.
    </p>
  );
});

export default function RestartTooltip() {
  return (
    <Tooltip
      placement="top"
      content={<RestartText />}
      channel="desktop"
      distance={15}
    >
      <img
        src="https://assets.thdstatic.com/images/v1/info.svg"
        className=""
        height=""
        width=""
        alt="info icon"
      />
    </Tooltip>
  );
}
